// extracted by mini-css-extract-plugin
var _1 = "PostStateBarActions-module__animateUploadProgressBarWidth--Zutg9";
var _2 = "PostStateBarActions-module__animatedBackground--cOshp";
var _3 = "PostStateBarActions-module__container--qOsK6";
var _4 = "PostStateBarActions-module__isOpen--tTEW5";
var _5 = "PostStateBarActions-module__overflowMenuButton--Ger1O";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "container", _4 as "isOpen", _5 as "overflowMenuButton" }
